import Avatar from "@mui/material/Avatar";
import PersonIcon from "@mui/icons-material/Person";

// Shows the user's photo; if there's no imageUrl, or it fails to load
// (MUI Avatar falls back to children on img error automatically), shows
// a generic person icon instead of a broken-image icon or text initials.
const UserAvatar = ({ src, name, sx, ...props }) => (
  <Avatar src={src || undefined} alt={name || "User"} sx={{ bgcolor: "#104581", ...sx }} {...props}>
    <PersonIcon />
  </Avatar>
);

export default UserAvatar;
